// Services.js
import React from 'react';
import './Home.css';

function Services() {
    return (
        // <section id="services" className="services-section">
        <div className="home-container">
            <h1>Under maintenance ...</h1>
        </div>
        // </section>
    );
}

export default Services;
